import {
    Col,
    Input,
    Modal,
    ModalBody,
    ModalFooter,
    Row,
    Spinner,
} from 'reactstrap';
import more_vert from "../../../../assets/V2-images/more_vert.png";
import deleteicon from "../../../../assets/V2-images/deleteicon.png";
import cartimg from "../../../../assets/V2-images/cartimg.svg";
import cartpdf from "../../../../assets/V2-images/cartpdf.svg";
import cartvideo from "../../../../assets/V2-images/cartvideo.svg";
import InputC from "Common/Inputs/index.tsx"
import { ButtonC } from 'Common/Buttons';
import { useEffect, useState } from 'react';
import { SVG } from 'components/HeadlessCMS/svg';
import backarrow from "../../../../assets/V2-images/left-arrow.svg"
import DropZoneC from 'Common/DropZoneC/index.tsx';
import { useDispatch, useSelector } from 'react-redux';
import { Gallery } from 'react-grid-gallery';
import Axios from 'functions/Axios';
import { CMS_API_URL } from 'Constant';
import { GetMedia } from 'actions/headlesscmsActions';
import { toast } from 'react-toastify';
import DropZoneMultiC from 'Common/DropZoneC/indexMulti.tsx';
import Nodatacomponent from 'components/Nodatacomponent';
import Pagination from 'components/Pagination';
import { stompService } from 'services/socketService';
const config = {
    headers: {
        'Content-Length': 10020,
        'Content-Type': 'multipart/form-data',
    },
};
export const DropZoneModel = (isOpen, togglemodel, media, save, data = [], domainId, pagination, GetMedia) => {
    const [images, setimages] = useState([])
    const [supportWebp, setSupportWebp] = useState(false);
    const dispatch = useDispatch()
    const [SelectedImages, setSelectedImages] = useState(data?.selected)



    const [uploadimage, setuploadimageimages] = useState(null)
    const [loading, setloading] = useState(false)
    const [searchTerm, setSearchTerm] = useState("");



    const handlePageChange = (event) => {
        // setState({
        //     ...state,
        //     offset: event.currentPage,
        // });

        GetMedia(domainId, event.currentPage - 1, searchTerm)

    };



    useEffect(() => {
        if (isOpen) {
            const selectedIds = (data?.selected || [])
                .map(item => item.mediaFileId)
                .filter(Boolean)
            GetMedia(domainId, 0, searchTerm, selectedIds)
        }
    }, [domainId, searchTerm, isOpen])


    const handleSave = async () => {
        try {
            const image = SelectedImages;

            // ✅ Upload new image
            if (uploadimage) {
                setloading(true);

                const formData = new FormData();
                formData.append("mediaFiles", uploadimage);

                await Axios.post(
                    `${CMS_API_URL}/media/create/${domainId}`,
                    formData,
                    config
                );

                setuploadimageimages(null);

                await (GetMedia(domainId));

                // togglemodel();
                return;
            }
            // ❌ Required image validation
            if (data?.data?.required && image.length === 0) {
                toast.error("No image is selected.");
                return;
            }

            // ✅ Save existing selection
            if (data.component) {
                save(
                    data.component,
                    data.data.name,
                    image,
                    data.index,
                    data.parent,
                    data?.parentindex
                );
            } else if (data?.data?.name) {
                save(data.data.name, image);
            }

            togglemodel();
        } catch (error) {
            console.error("Media save error:", error);

            // 🔔 User-friendly error message
            toast.error(
                error?.response?.data?.message ||
                "Something went wrong while saving media."
            );
        } finally {
            // ✅ Always stop loader
            setloading(false);
        }
    };

    useEffect(() => {
        if (media) {

            setSelectedImages(data?.selected || [])
            const arr = media.map(item => {
                const dataarray = data?.selected === "" ? [] : data?.selected

                const isExist = dataarray?.some(dataItem => item.filePath === dataItem.filePath);
                const dataitem = {
                    ...item,
                    src: item.thumbnailPath === null ? "/manage/images/product_placeholder.png" : item.thumbnailPath,
                    filePath: item.filePath,
                    isSelected: isExist,
                }
                delete dataitem.createdAt;
                delete dataitem.updatedAt;
                return dataitem
            });
            setimages(arr);
        }
    }, [media, data]);

    const handleSelect = (e, item) => {
        if (data.type === 2) {
            // If the image is already selected, deselect it
            if (images[e].isSelected) {
                const updatedImages = images.map(img => ({ ...img, isSelected: false }));
                setimages(updatedImages);
                setSelectedImages([])


            } else {
                // Automatically deselect all images and select the new one
                const updatedImages = images.map((img, index) =>
                ({
                    ...img, isSelected: index === e,

                })
                );
                setimages(updatedImages);
                setSelectedImages([item])

            }
        } else {
            // Toggle the selected state of the clicked image
            const indexw = SelectedImages?.findIndex(dataItem => item.filePath === dataItem.filePath);
            setSelectedImages((prevImages) => {
                if (indexw !== null && indexw !== undefined && indexw !== -1) {
                    // If the item already exists in the array, remove it
                    return prevImages?.filter((_, index) => index !== indexw);
                } else {
                    // If the item does not exist, add it to the array
                    return [...prevImages, item];
                }
            });

            setimages(prevImages =>
                prevImages.map((img, index) =>
                    index === e ? { ...img, isSelected: !img.isSelected } : img
                )
            );
        }
    };



    function supportFormatWebp() {
        const img = new Image();
        img.onload = function () {
            setSupportWebp(img.naturalWidth > 0 || img.naturalHeight > 0);
        };
        img.src = "data:image/avif;base64,...";
    }

    // useEffect(() => {
    //     supportFormatWebp();
    // }, []);
    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };
    useEffect(() => {
        const subscription = stompService.subscribe(
            "/user/topic/media.cms.final",
            (payload) => {
                try {
                    GetMedia(domainId, pagination.currentPage || 0, searchTerm);
                } catch (err) {
                    console.error("Invalid CMS payload:", err);
                }
            }
        );

        return () => {
            if (subscription?.unsubscribe) subscription.unsubscribe();
        };
    }, [domainId, pagination.currentPage, searchTerm]);
    return (
        <>
            <Modal isOpen={isOpen} size="xl" toggle={togglemodel} keyboard={true} backdrop={true}>
                <ModalBody style={{ minWidth: "1000px", maxHeight: "800px", overflow: "auto" }}>
                    <div className='d-flex justify-content-between'>
                        <h4>Upload Assets in Media Library</h4>
                        <div className='cursor-pointer' onClick={togglemodel}>
                            {SVG.cross}
                        </div>
                    </div>
                    <div className='pt-3 pb-5 modeldropdown p-3'>
                        <DropZoneC
                            DropZoneText="Drag & drop files here or Choose file"
                            previewposition="bottom"
                            setimage={setuploadimageimages}
                            image={uploadimage}
                        />
                    </div>
                    <h6>Select Assets for Content</h6>
                    <div>
                        <div className="d-flex justify-content-between mb-3">
                            <InputC type="Searchbar" placeholder="Search Image Name" change={handleSearchChange} />
                        </div>
                        <Row>
                            {
                                images.length === 0 ?

                                    <div className="d-flex justify-content-center align-items-center w-100">
                                        <div className="w-25">
                                            <Nodatacomponent />
                                        </div>
                                    </div>

                                    :

                                    images?.map((value, index) => {
                                        var indexw
                                        const isActive = value.status === "APPROVED"
                                        const status = value.status
                                        if (value.isSelected) {

                                            indexw = SelectedImages?.findIndex(dataItem => value.filePath === dataItem.filePath) + 1

                                        }
                                        return (
                                            <Col xl={3} key={value.mediaFileId}>
                                                <div className="boxdata mb-4" style={{ position: "relative", opacity: status === "FAILED" ? 0.6 : 1 }}>
                                                    {/* <div className='SelectCount'>
                                                        1
                                                    </div> */}
                                                    <div className="d-flex justify-content-between align-items-center imagecart">
                                                        <img src={
                                                            value.mediaType === "image" ? cartimg :
                                                                value.mediaType === "pdf" ? cartpdf : cartvideo
                                                        } alt=".." className="pointer" />

                                                        <div className="d-flex align-items-center">
                                                            {
                                                                value.isSelected && (
                                                                    <div className="d-flex align-items-center checkbox-container" style={{ paddingLeft: "6px" }}>
                                                                        <div className='SelectCount2'>
                                                                            {indexw}
                                                                        </div>
                                                                    </div>
                                                                )
                                                            }
                                                            <div className="d-flex align-items-center checkbox-container" style={{ paddingLeft: "6px" }}>
                                                                <Input
                                                                    className="draft-checkboxes"
                                                                    type="checkbox"
                                                                    disabled={!isActive}
                                                                    onClick={() => handleSelect(index, value)}
                                                                    checked={value.isSelected}
                                                                    readOnly
                                                                />
                                                            </div>
                                                            {/* <img src={more_vert} alt="more_vert" className="pointer" onClick={() => handleShow(value.mediaFileId)} /> */}
                                                        </div>

                                                    </div>
                                                    <div className={`filethumb ${value.fileFormat === "png" && value.transparent === "true" ? "fileback" : ""}`}>
                                                        <a href={value.filePath} target="_blank" rel="noreferrer">
                                                            {
                                                                isActive ?
                                                                    <div
                                                                        className="imageshowh"
                                                                        style={{ backgroundImage: `url(${value.thumbnailPath})` }}
                                                                    /> :
                                                                    <>
                                                                        {
                                                                            status === "FAILED" ?

                                                                                <div className="position-relative d-flex justify-content-center align-items-center imageshowh">
                                                                                    {/* Background overlay with opacity */}
                                                                                    <div
                                                                                        className="position-absolute top-0 start-0 w-100 h-100"
                                                                                        style={{
                                                                                            backgroundSize: "cover",
                                                                                            backgroundPosition: "center",
                                                                                            opacity: 0.5,
                                                                                            zIndex: 0,
                                                                                        }}
                                                                                    ></div>

                                                                                    {/* Foreground content */}
                                                                                    <div className="position-relative" style={{ zIndex: 1 }}>
                                                                                        <img src="/manage/images/Toast-svg/Error.svg" className="imageSize" alt="Error" />
                                                                                    </div>
                                                                                </div>

                                                                                :
                                                                                <div className="position-relative d-flex justify-content-center align-items-center imageshowh">
                                                                                    {/* Background overlay with opacity */}
                                                                                    <div
                                                                                        className="position-absolute top-0 start-0 w-100 h-100"
                                                                                        style={{
                                                                                            backgroundSize: "cover",
                                                                                            backgroundPosition: "center",
                                                                                            opacity: 0.5,
                                                                                            zIndex: 0,
                                                                                        }}
                                                                                    ></div>

                                                                                    {/* Foreground content */}
                                                                                    <div className="position-relative" style={{ zIndex: 1 }}>
                                                                                        <Spinner />
                                                                                    </div>
                                                                                </div>
                                                                        }
                                                                    </>
                                                            }

                                                        </a>
                                                    </div>
                                                    <div className="bottomtext">
                                                        {
                                                            isActive ?
                                                                <>
                                                                    {value.fileOriginalName.length > 7
                                                                        ? `${value.fileOriginalName.substring(0, 7)}...${value.fileOriginalName.substring(value.fileOriginalName.lastIndexOf("."))}`
                                                                        : value.fileOriginalName}
                                                                </> :
                                                                <>
                                                                    {
                                                                        status === "FAILED" ?
                                                                            <div style={{ color: "red" }}>
                                                                                Failed
                                                                            </div>

                                                                            :
                                                                            "Scanning"
                                                                    }

                                                                </>


                                                        }

                                                    </div>
                                                </div>
                                            </Col>
                                        );
                                    })}
                        </Row>
                        {
                            pagination.totalPages > 1 && (
                                <Pagination
                                    type="Sticky"
                                    fixed={true}
                                    // ref={paginationCollectionRef}
                                    pageNeighbours={1}
                                    changePageNo={handlePageChange}
                                    onPageChanged={handlePageChange}
                                    totalRecords={pagination.totalRecord}
                                    pageLimit={parseInt(pagination.pageSize)}
                                    currentPage={parseInt(pagination.currentPage) + 1}
                                    totalPages={pagination.totalPages}
                                />
                            )
                        }

                    </div>
                </ModalBody>
                <ModalFooter>
                    <div className='d-flex justify-content-end align-items-center gap-3'>
                        <ButtonC text="Cancel" size="lg" color="Secondary" click={togglemodel} />
                        {
                            loading ?
                                <ButtonC text="Save" size="lg">
                                    <Spinner color="#e6e6e6" size="sm" className="mx-1" />
                                </ButtonC>

                                :
                                <ButtonC text="Save" size="lg" click={handleSave} />

                        }
                    </div>
                </ModalFooter>
            </Modal>
        </>
    );
};

export const DropZonePopUp = (isOpen, togglemodel, domainId) => {
    const [images, setimages] = useState(null)
    const [loading, setloading] = useState(false)
    const dispatch = useDispatch()
    const handleSave = async () => {
        try {
            setloading(true)
            const formData = new FormData()
            images.map(item => {

                formData.append("mediaFiles", item)
            })
            // var length = [...images, ...images, ...images, ...images, ...images, ...images, ...images]
            await Axios.post(`${CMS_API_URL}/media/create/${domainId}`, formData, {
                headers: {
                    'Content-Length': images.toString().length + 11000,
                    'Content-Type': 'multipart/form-data',
                },
            })
            dispatch(GetMedia(domainId))
            setTimeout(() => {
                dispatch(GetMedia(domainId))
            }, 5000);
            setloading(false)
            setimages(null)
            togglemodel()
        } catch (error) {
            setloading(false)
            setimages(null)
        }

    }

    return (
        <>
            <Modal isOpen={isOpen} size="xl" toggle={togglemodel} keyboard={true} backdrop={true}>
                <ModalBody style={{ minWidth: "1000px" }}>
                    <div className='d-flex justify-content-between'>
                        <h4>Upload Assets</h4>
                        <div className='cursor-pointer' onClick={togglemodel}>
                            {SVG.cross}
                        </div>
                    </div>
                    <div className='pt-3 pb-5 modeldropdown p-3'>
                        <DropZoneMultiC
                            classname=""
                            DropZoneText="Drag & drop files here or Choose file"
                            previewposition="original"
                            setimage={setimages}
                            image={images}
                        />
                    </div>

                    <div className='d-flex justify-content-end align-items-center gap-3'>
                        <ButtonC text="Cancel" size="lg" color="Secondary" click={togglemodel} />
                        {
                            loading ?
                                <ButtonC text="Save" size="lg">
                                    <Spinner color="#e6e6e6" size="sm" className="mx-1" />
                                </ButtonC>

                                :
                                <ButtonC text="Save" size="lg" click={handleSave} />

                        }
                    </div>
                </ModalBody>
            </Modal>
        </>
    );
};